import { action, atom } from '@reatom/framework'

import { reatomUpdatePremiumCurrency } from '@root/features/premium/update-currency'
import { atomWithPrev } from '@root/shared/lib'

import type { PremiumMetaModel } from '@root/entities/premium'

export const reatomUpdateBannerDrawer = ({
  premiumMeta,
}: {
  premiumMeta: PremiumMetaModel
}) => {
  const { updateCurrencyAction, updateRequestState, resetStateAction } =
    reatomUpdatePremiumCurrency()

  const bannerAtom = atom<File | undefined>(undefined, 'bannerAtom')

  const setBannerAction = action((ctx, banner: File) => {
    bannerAtom(ctx, banner)
  }, 'setBannerAction')

  const updateBannerAction = action((ctx) => {
    const banner = ctx.get(bannerAtom)
    const premiumId = ctx.get(premiumMeta.premiumId)
    if (!banner || !premiumId) {
      return
    }
    updateCurrencyAction(ctx, {
      banner,
      premiumId,
      currencyAddress: premiumMeta.currencyAddress,
    })
  }, 'updateBannerAction')

  const bannerPreviewAtom = atomWithPrev<string | undefined>(
    (ctx, previousImage) => {
      if (previousImage) {
        URL.revokeObjectURL(previousImage)
      }

      const banner = ctx.spy(bannerAtom)
      return banner ? URL.createObjectURL(banner) : undefined
    },
    'bannerPreviewAtom',
  )

  const clearBannerAction = action((ctx) => {
    bannerAtom(ctx, undefined)
  }, 'clearBannerAction')

  const resetAction = action((ctx) => {
    bannerAtom(ctx, undefined)
    resetStateAction(ctx)
  }, 'resetAction')

  return {
    updateRequestState,
    updateBannerAction,
    setBannerAction,
    clearBannerAction,
    bannerAtom,
    bannerPreviewAtom,
    resetAction,
  }
}
